import styled from '@emotion/styled';
import { ChangeEvent, FC } from 'react';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

type Props = {
  name: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const UploadButton: FC<Props> = ({ name, onChange, children }) => {
  return (
    <StyledLabel htmlFor={`upload-button-${name}`}>
      {children}
      <input
        accept="image/*"
        id={`upload-button-${name}`}
        name={name}
        multiple
        type="file"
        onChange={onChange}
        style={{ display: 'none' }}
      />
    </StyledLabel>
  );
};

const StyledLabel = styled('label')({
  display: 'inline-flex',
  justifyContent: 'center',
  cursor: 'pointer',
  alignItems: 'center',
  height: '32px',
  padding: '5px 15px',
  fontSize: '14px',
  fontWeight: 'bold',
  borderRadius: '4px',
  color: COLOR_TEXT_MAIN,
  background: '#FFFFFF',
  border: '1.5px solid #E6E7E8',
  marginRight: '16px',
  ':hover': {
    background: '#FFFFFF',
  },
});

export default UploadButton;
